<template>
  <div class='df-tag'>
    <div class="label-box w100">
      <div class="label-box-content flex" v-for="(item,i) in list" :key="i">
        <template v-if="item.list.length">
          <p class="label-box-label">{{item.label}}</p>
          <div class="label-box-item flex aic fww flex-1">
            <p v-for="(val,ind) in item.list" :key="ind" class="csp" :class="{'label-box-active':info[item.prop] == val.id}" @click="changeTag(val,item.prop)">
              {{val[labelName] || val.short_name || val.name}}</p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DfTag',
  props: {
    // 显示的数据
    list: {
      type: Array,
      default: []
    },
    // 显示对应的字段信息
    info: {
      type: Object,
      default: {}
    },
    labelName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
    changeTag (item, prop) {
      this.$emit('change', item, prop);
    }
  }
}
</script>

<style scoped lang='less'>
@act-color: #1177ff;
.label-box {
  background: #f7f8fa;
  border-radius: 8px;
  padding: 16px 24px 0;
  margin-bottom: 24px;
  &-label {
    padding-right: 27px;
    padding-top: 3px;
  }
  &-item {
    .label-box-active {
      background: #e1eeff;
      color: @act-color;
      border-radius: 14px;
      font-weight: bold;
    }
    p {
      margin-bottom: 16px;
      color: #666f7a;
      line-height: 28px;
      padding: 0 16px;
      &:hover {
        color: @act-color;
      }
    }
  }
}
</style>

